import { Box, Flex, Textarea, IconButton } from "@chakra-ui/react";
import { ArrowUpIcon } from "@chakra-ui/icons";

interface HeroInputProps {
  value: string;
  onSubmit: () => void;
  disabled?: boolean;
}

const HeroInput: React.FC<HeroInputProps> = ({ value, onSubmit, disabled }) => {
  return (
    <Box
      w="100%"
      //   maxW="900px"
      minH={{ base: "80px", md: "80px" }}
      bg="#EBEFF9"
      borderRadius="24px"
      px={{ base: 4, md: 6 }}
      py={{ base: 3, md: 5 }}
      mt={3}
    >
      <Flex gap={3} position="relative" minH="inherit" align="stretch">
        <Textarea
          value={value}
          aria-label="Pregunta para el asistente de SAGA Fiscal"
          placeholder="Haz una pregunta..."
          resize="none"
          border="none"
          isReadOnly
          fontSize="md"
          _focus={{ boxShadow: "none" }}
          minH="100%"
        />

        <IconButton
          position="absolute"
          right={0}
          bottom={0}
          aria-label="Enviar"
          icon={<ArrowUpIcon />}
          bg="#0E2EFB"
          color="white"
          borderRadius="full"
          isDisabled={disabled || !value}
          onClick={onSubmit}
          _hover={{ bg: "#1A3CFF" }}
        />
      </Flex>
    </Box>
  );
};

export default HeroInput;
